module.exports = __webpack_public_path__ + "static/img/50.a80f70a3.png";